import { createIcon } from '../icon'
import CategoriesIcon from '../svg/CategoriesIcon'

export const CategoriesIconDefault = createIcon(CategoriesIcon)
